<div mat-dialog-header class="title">
  Export Data
</div>
<div mat-dialog-content>
  <div *ngIf="!isLoading" class="flex-row">
    <div class="icon-box" (click)="reportExport()">
      <mat-icon svgIcon="pdf"></mat-icon>
      <span>Get Report</span>
    </div>
    <a *ngIf="token$|async" target="api" [href]="apiUrl$|async">
      <div class="icon-box">
        <mat-icon style="color:#707FFF">api</mat-icon>
        <span>Get API</span>
      </div>
    </a>
    <div class="icon-box" (click)="openCSVDialog()">
      <mat-icon svgIcon="csv"></mat-icon>
      <span>Get CSV</span>
    </div>
  </div>
  <div *ngIf="isLoading" class="container centered-content">
    <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
  </div>
  <div mat-dialog-actions class="footer">
    <button mat-button (click)="cancel()">Cancel</button>
  </div>
</div>